module.exports = __webpack_public_path__ + "static/media/LV5@4x.e73b6897.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/LV/LV5@4x.png
// module id = 689
// module chunks = 0